import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import InputText from '../../../components/FormFields/InputText';
import TextArea from '../../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from '../components/PageHeader';
import {useHistory} from 'react-router-dom';
import {
  getAllSubProcesses,
  addPotentialRisk,
  getRiskEstimations,
  getAllSubCauses,
  getMethodology,
  getDepartment,
} from '../../../services/potentialRiskService';
import SelectList from '../../../components/select/SelectList';
import './AddPotentialRisk.scss';
import {useUserContext} from '../../../contexts/UserContext';
import Toast from '../../../components/toast/Toast';
import Trash from '../img/trash.svg';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import allowedFileTypes from '../../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../../components/preventTransitionprompt/PreventTransition';

const AddPotentialRisk = () => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [disableSubCauses, setDisableSubCauses] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const disableRiskEstimation = true;
  const [riskEstimation, setRiskEstimation] = useState('');
  const [riskEstimationId, setRiskEstimationId] = useState();
  const [riskEstimationColor, setRiskEstimationColor] = useState();
  const [files, setFiles] = useState([]);
  const [isAdding, setIsAdding] = useState(true);
  const [methodology, setMethodology] = useState();

  let history = useHistory();

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      potentialRiskType: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCause: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCause: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      riskCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocess: yup.object().nullable().required(t('message.fieldRequired')),
      businessLine: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      methodology: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholder: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      frequencyOccurrenceOr: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      financialPerformance: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue} = methods;
  const watchProcess = watch('process');
  const watchFrequencyOccurrenceOr = watch('frequencyOccurrenceOr');
  const watchFinancialPerformance = watch('financialPerformance');
  const watchRiskCause = watch('riskCause');
  const watchDepartmentSourceId = watch('departmentSourceId');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      return data;
    } catch (e) {}
  };

  const fetchSubcauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  const fetchMethodology = async () => {
    try {
      const {data} = await getMethodology();
      data.map((i) => {
        if (i === 2) {
          setMethodology({
            value: i.id,
            label: lang === 'mne' ? i.name : i.nameEn,
          });
        }
      });
      //setMethodology({data})
      return data;
    } catch (e) {}
  };

  const fetchRiskEstimation = async () => {
    try {
      const {data} = await getRiskEstimations(
        watchFrequencyOccurrenceOr['value'],
        watchFinancialPerformance['value']
      );
      return data;
    } catch (e) {}
  };

  const handleCancel = (e) => {
    e.preventDefault();
    // TO-DO redirect to risks
    window.location = '/dashboard';
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const payload = {
      applicationDate: new Date(),

      title: data.title,
      potentialRiskTypeId: data.potentialRiskType.value,
      description: data.description,
      riskCauseId: data.riskCause.value,
      riskSubCauseId: data.riskSubCause.value,
      riskCategoryId: data.riskCategory.value,
      riskTypeId: 1,
      userCreatedId: user.id,
      userInChargeId: user.id,
      userInChargeLogin: user.login,
      // userResponsibleId: userDepartment[0].userResponsibleId,
      userResponsibleId: data.userResponsible.value,
      userResponsibleLogin: userDepartment[0].userResponsibleLogin,
      processId: data.process.value,
      subprocessId: data.subprocess.value,
      businessLineId: data.businessLine.value,
      methodologyId: data.methodology.value,
      departmentStakeholderId: data.departmentStakeholder.value,
      departmentSourceId: data.departmentSourceId.value,
      riskEstimationId: riskEstimationId,
      riskMitigationModeId: data.riskMitigationModeName?.value,
      riskMitigationModeName: data.riskMitigationModeName?.label,
      comment: data.comment
    };

    try {
      const response = await addPotentialRisk(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('potentialRisk.messages.addSuccess'),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/potential-risk/${response.data.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('potentialRisk.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('potentialRisk.messages.addError'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };

  useEffect(() => {
    if (watchProcess?.value) {
      setDisableSubPorcess(false);
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    setValue('subprocess', '');
    if (watchProcess === null) {
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  useEffect(() => {
    if (watchRiskCause?.value) {
      setDisableSubCauses(false);
      fetchSubcauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);

  const getRiskColor = (risk) => {
    if(risk.color === 'PINE_GREEN') {
      setRiskEstimationColor('#027148')
    }
    if (risk.color === 'RED') {
      setRiskEstimationColor('#f5501f');
    }
    if (risk.color === 'YELLOW') {
      setRiskEstimationColor('#f59a1f');
    }
    if (risk.color === 'GREEN') {
      setRiskEstimationColor('#37c35c');
    }
    if(risk.color === 'ORANGE') {
      setRiskEstimationColor('#FFBF00')
    }
  };

  useEffect(() => {
    if (watchFrequencyOccurrenceOr?.value && watchFinancialPerformance?.value) {
      fetchRiskEstimation().then((r) => {
        const risk = r[0];
        if (risk.evaluation !== riskEstimation) {
          setRiskEstimation(
            lang === 'eng' ? risk.evaluationEn : risk.evaluation
          );
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        } else {
          // Needs to be set 2 times since key rerender reacts only on change
          setRiskEstimation('');
          setRiskEstimation(riskEstimation);

          setRiskEstimationColor('');
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        }
      });
    }
    setValue('riskEstimation', '');
    if (
      watchFrequencyOccurrenceOr === null ||
      watchFinancialPerformance === null
    ) {
      setValue('riskEstimation', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchFrequencyOccurrenceOr, watchFinancialPerformance]);

  useEffect(() => {
    fetchMethodology();
  }, []);

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        const allowedTypesArray = allowedFileTypes.split(',');
        let fileExtension = input.files
          .item(i)
          .name.substring(input.files.item(i).name.lastIndexOf('.')).toLowerCase();
        if (!allowedTypesArray.includes(fileExtension)) {
          Toast.fire({
            title: t('message.fileTypeNotAllowed', {
              entity: input.files.item(i).name,
            }),
            icon: 'error',
          });
        } else {
          if (input.files.item(i).size > 10485760) {
            Toast.fire({
              title: t('message.fileTooBig'),
              icon: 'error',
            });
          } else {
            children.push({
              id: input.files.item(i).name,
              label: input.files.item(i).name,
            });
            setFiles(children);
          }
        }
      }
    }
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file. thus removing it.
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setValue('userResponsible', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">
                {t('potentialRisk.mainData')}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  id="title"
                  className="form-control input-field"
                  placeholder={t('potentialRisk.placeholder.title')}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.potentialRiskType')}
                </label>
                <SelectInfinite
                  api="potential-risk-types"
                  name="potentialRiskType"
                  placeholder={t('potentialRisk.placeholder.potentialRiskType')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.description')}
                </label>
                <TextArea
                  name="description"
                  className={`form-control text-area `}
                  placeholder={t('potentialRisk.placeholder.description')}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-6 col-xl-3">
                {t('potentialRisk.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.riskCategory')}
                </label>
                <SelectInfinite
                  api="risk-categories"
                  name="riskCategory"
                  placeholder={t('potentialRisk.placeholder.riskCategory')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskCause')}
                </label>
                <SelectInfinite
                  api="risk-causes"
                  name="riskCause"
                  placeholder={t('potentialRisk.placeholder.riskCause')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskSubCause')}
                </label>

                <SelectList
                  name="riskSubCause"
                  isDisabled={disableSubCauses}
                  className="select"
                  placeholder={t('potentialRisk.placeholder.riskSubCause')}
                  options={subCauses}
                  isClearable
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.businessLine')}
                </label>
                <SelectInfinite
                  api="business-lines"
                  name="businessLine"
                  placeholder={t('potentialRisk.placeholder.businessLine')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.process')}
                </label>
                <SelectInfinite
                  api="processes"
                  name="process"
                  placeholder={t('potentialRisk.placeholder.process')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.subprocess')}
                </label>
                <SelectList
                  name="subprocess"
                  isDisabled={disableSubprocess}
                  placeholder={t('potentialRisk.placeholder.subprocess')}
                  options={subProcesses}
                  isClearable
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.methodology')}
                </label>
                <SelectInfinite
                  api="methodologies"
                  name="methodology"
                  placeholder={t('potentialRisk.placeholder.methodology')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  defaultValue={methodology}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentRisk')}
                </label>
                {userDepartment?.length === 1 ? (
                  <SelectInfinite
                    api="departments/departments-user-in-charge"
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    defaultValue={{
                      value:
                        userDepartment[0]?.id !== undefined
                          ? userDepartment[0]?.id
                          : '',
                      label:
                        userDepartment[0]?.id !== undefined
                          ? lang === 'mne'
                            ? userDepartment[0]?.name
                            : userDepartment[0]?.nameEn
                          : '',
                    }}
                    isDisabled={true}
                  />
                ) : (
                  <SelectInfinite
                    api="departments/departments-user-in-charge"
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                  />
                )}
                <label className="label-potential-risk">
                  {t('potentialRisk.frequencyOccurrenceOr')}
                </label>
                <SelectInfinite
                  api="frequency-occurence-risks"
                  name="frequencyOccurrenceOr"
                  placeholder={t(
                    'potentialRisk.placeholder.frequencyOccurrenceOr'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentStakeholder')}
                </label>
                <SelectInfinite
                  api="departments"
                  name="departmentStakeholder"
                  placeholder={t(
                    'potentialRisk.placeholder.departmentStakeholder'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                {userDepartment?.length === 1 ? (
                  <>
                    <label className="label-potential-risk">
                      {t('potentialRisk.userResponsible')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'potentialRisk.placeholder.userResponsible'
                      )}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleId
                            : '',
                        label:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleFirstName +
                              ' ' +
                              userDepartment[0]?.userResponsibleLastName
                            : '',
                      }}
                    />
                  </>
                ) : (
                  <>
                    <label className="label-potential-risk">
                      {t('potentialRisk.userResponsible')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'potentialRisk.placeholder.userResponsible'
                      )}
                      className="select"
                      isDisabled={true}
                    />
                  </>
                )}

                <label className="label-potential-risk">
                  {t('potentialRisk.financialPerformance')}
                </label>
                <SelectInfinite
                  api="financial-performances"
                  name="financialPerformance"
                  placeholder={t(
                    'potentialRisk.placeholder.financialPerformance'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.riskEstimation')}
                </label>
                {/*Can't use InputText component since it has ref register and color needs to change*/}
                {/*passing !important trough another ref since react doesn't accept it in inline style as variable (#ffffff !important)*/}
                <input
                  key={riskEstimation}
                  className="form-control input-field"
                  value={riskEstimation.toUpperCase()}
                  type="text"
                  disabled={disableRiskEstimation}
                  ref={(el) => {
                    if (el) {
                      el.style.setProperty(
                        'color',
                        riskEstimationColor,
                        'important'
                      );
                    }
                  }}
                />
                <label className="label-potential-risk">
                  {t('mitigation-measures.method')}
                </label>
                <SelectInfinite
                    api="/risk-mitigation-modes"
                    name="riskMitigationModeName"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    placeholder={t('placeholder.riskMitigrationMethod')}
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk" htmlFor={'attachFile'}>
                  {t('potentialRisk.attachFiles')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <InputText
                  id="upload"
                  type="file"
                  name="file"
                  multiple
                  className="file-input"
                  onChange={uploadOnChange}
                  accept={allowedFileTypes}
                />
                <div key={files}>
                  <ul>
                    {files.map((file, index) => (
                      <li key={file.id}>
                        <div className="d-flex align-items-center">
                          <span className="mr-2">{file.label}</span>
                          <img
                            src={Trash}
                            alt="trash"
                            onClick={(e) => {
                              e.preventDefault();
                              clearLocalFile(index);
                            }}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.comment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                  name="comment"
                  className={`form-control text-area`}
                  placeholder={t('potentialRisk.placeholder.comment')}
                />
              </Col>
            </Row>
            <Row className="mt-5 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn">{t('buttons.save')}</button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
export default AddPotentialRisk;
